module.exports = __webpack_public_path__ + "img/SEAT.a5d509e.jpg";